import getAddonElementsUsedInSpread from 'editor/src/store/design/selector/getAddonElementsUsedInSpread';
import getImageElementsUsedInSpread from 'editor/src/store/design/selector/getImageElementsUsedInSpread';
import getTextElementsUsedInSpread from 'editor/src/store/design/selector/getTextElementsUsedInSpread';
import { Spread } from 'editor/src/store/design/types';
import { LayoutSchema } from 'editor/src/store/editorModules/layouts/types';

import { RootState } from 'editor/src/store';
import generateLayout from 'editor/src/util/layouts/generateLayout';
import generateLayoutMediaElements from 'editor/src/util/layouts/generateLayoutMediaElements';
import notUndefined from 'editor/src/util/notUndefined';

import getAppliedLayoutSchemaToSpreadMedia, { getImageWithDimensions } from './getAppliedLayoutSchemaToSpreadMedia';
import getLayoutBBox from './getLayoutBBox';
import isStaticElement from './isStaticElement';

import type { i18n } from 'i18next';

const applyLayoutSchemaToSpread = (
  state: RootState,
  spread: Spread,
  spreadIndex: number,
  layoutSchema: LayoutSchema,
  i18n: i18n,
) => {
  const bbox = getLayoutBBox(layoutSchema, spread);
  if (!bbox.width || !bbox.height) {
    return;
  }

  const layoutFrames = generateLayout(layoutSchema, bbox.left, bbox.top, bbox.width, bbox.height);

  const layoutElements = generateLayoutMediaElements(state, spreadIndex, spread, layoutFrames, i18n);

  // Static elements must survive a layout switch untouched: keep their geometry and flags rather
  // than reflowing them into a frame (GAPI-45762). See isStaticElement. Exclude them here and
  // re-append them verbatim below.
  const staticElements = (spread.pages[0].groups.media ?? []).filter(isStaticElement);

  const imageElementsToPlace = getImageElementsUsedInSpread(spread)
    .filter((img) => !isStaticElement(img))
    .map((img) => getImageWithDimensions(state, img))
    .filter(notUndefined);
  const addonElementsToPlace = getAddonElementsUsedInSpread(spread).filter((el) => !isStaticElement(el));
  const textElementsToPlace = getTextElementsUsedInSpread(spread).filter((el) => !isStaticElement(el));

  const media = getAppliedLayoutSchemaToSpreadMedia(
    spread,
    layoutElements,
    {
      text: textElementsToPlace,
      image: imageElementsToPlace,
      addon: addonElementsToPlace,
    },
    false,
  );

  spread.pages[0].groups.media = [...media, ...staticElements];
  spread.layoutSchemaName = layoutSchema.name;
};

export default applyLayoutSchemaToSpread;
